export const ASSOCIADO = () => `/associado`;
export const ASSOCIADOEDIT = () => `/associado/edit`;
export const ASSOCIADOSUBSTITUIR = () => `/associado/substituir`;

